<template>
  <div>
    <DxPopup
      :visible="this.isVisible"
      :drag-enabled="false"
      :close-on-outside-click="false"
      :show-title="true"
      :show-close-button="false"
      :width="900"
      :height="800"
      :title="title"
    >
      <div class="row">
        <DxHtmlEditor height="600px" v-model="markup">
          <DxMediaResizing :enabled="true" />
          <DxToolbar :multiline="isMultiline">
            <DxItem format-name="undo" />
            <DxItem format-name="redo" />
            <DxItem format-name="separator" />
            <DxItem :format-values="sizeValues" format-name="size" />
            <DxItem :format-values="fontValues" format-name="font" />
            <DxItem format-name="separator" />
            <DxItem format-name="bold" />
            <DxItem format-name="italic" />
            <DxItem format-name="strike" />
            <DxItem format-name="underline" />
            <DxItem format-name="separator" />
            <DxItem format-name="alignLeft" />
            <DxItem format-name="alignCenter" />
            <DxItem format-name="alignRight" />
            <DxItem format-name="alignJustify" />
            <DxItem format-name="separator" />
            <DxItem format-name="orderedList" />
            <DxItem format-name="bulletList" />
            <DxItem format-name="separator" />
            <DxItem :format-values="headerValues" format-name="header" />
            <DxItem format-name="separator" />
            <DxItem format-name="color" />
            <DxItem format-name="background" />
            <DxItem format-name="separator" />
            <DxItem format-name="link" />
            <DxItem format-name="image" />
            <DxItem format-name="separator" />
            <DxItem format-name="clear" />
            <DxItem format-name="codeBlock" />
            <DxItem format-name="blockquote" />
            <DxItem format-name="separator" />
            <DxItem format-name="insertTable" />
            <DxItem format-name="deleteTable" />
            <DxItem format-name="insertRowAbove" />
            <DxItem format-name="insertRowBelow" />
            <DxItem format-name="deleteRow" />
            <DxItem format-name="insertColumnLeft" />
            <DxItem format-name="insertColumnRight" />
            <DxItem format-name="deleteColumn" />
          </DxToolbar>
        </DxHtmlEditor>
      </div>
      <div class="row" style="padding-top: 20px">
        <div class="col-md-2">
          <DxButton
            text="Επιστροφή"
            type="danger"
            styling-mode="contained"
            @click="onClosePopup"
          />
        </div>
        <div class="col-md-3">
          <DxButton
            :width="130"
            text="Αποθήκευση"
            type="success"
            styling-mode="contained"
            @click="onSave"
          />
        </div>
      </div>
    </DxPopup>
  </div>
</template>


<script>
import { DxButton } from "devextreme-vue/button";
import { DxPopup } from "devextreme-vue/popup";
import {
  DxHtmlEditor,
  DxToolbar,
  DxMediaResizing,
  DxItem,
} from "devextreme-vue/html-editor";
import mainService from "../../services/mainService";
import notify from "devextreme/ui/notify";

export default {
  props: ["pageName", "isVisible"],
  components: {
    DxButton,
    DxPopup,
    DxHtmlEditor,
    DxMediaResizing,
    DxToolbar,
    DxItem,
  },
  data() {
    return {
      help: {},
      markup: "",
      sizeValues: ["8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt"],
      fontValues: [
        "Arial",
        "Courier New",
        "Georgia",
        "Impact",
        "Lucida Console",
        "Tahoma",
        "Times New Roman",
        "Verdana",
      ],
      headerValues: [false, 1, 2, 3, 4, 5],
      isMultiline: true,
      title: "",
    };
  },
  computed: {},
  methods: {
    onClosePopup(e) {
      this.$emit("emit-close-popup", {});
    },
    async onSave(e) {
      this.help.HelpText = this.markup;
      const res = await mainService.post(
        `/helpPages/UpdateHelpPage`,
        this.help
      );
      if (res.status == 200) {
        notify("Το αρχείο βοήθειας ενημερώθηκε", "success", 1000);
      }
    },
    getPageGreekTitle(pageName) {
      switch (pageName) {
        case "home":
          return "Κυρίως Σελίδα";
        case "organizationEmployees":
          return "Χρήστες Φορέα";
        case "users":
          return "Χρήστες";
        case "organizations":
          return "Φορείς";
        case "organization/":
          return "Φορέα";
        case "structures":
          return "Δομές";
        case "structure/":
          return "Δομή";
        case "contracts":
          return "Συμβάσεις";
        case "contract/":
          return "Σύμβαση";
        case "structureVacations":
          return "Αδράνειες Δομών";
        case "attendances":
          return "Παρουσίες";
        case "payments":
          return "Πληρωμές";
        case "adminTools":
          return "Εργαλεία Admin";
        case "parameters":
          return "Παράμετροι Εφαρμογής";
        case "verfications":
          return "Επιβεβαίωση Παρουσιών";
        case "userOrganizations":
          return "Φορείς Χρήστη";
        case "attendancesdetails/":
          return "Αναλυτική Λίστα Παρουσιών";
        case "globalParams":
          return "Γενικές Παράμετροι";
        case "unlockReasons":
          return "Λόγοι Ξεκλειδώματος";
        case "documents":
          return "Δικαιολογητικά";
        case "absenceReasons":
          return "Λόγοι Απουσίας";
        case "holidays":
          return "Αργίες";
        case "securityRules":
          return "Κανόνες Ασφαλείας";
        case "mobiles":
          return "Κινητά";
      }
    },
  },
  async mounted() {
    var initialPageName = this.pageName;
    var pageName = "";
    var _splited = initialPageName.split("/");
    pageName = _splited[1];
    if (_splited.length > 2) {
      pageName += "/";
    }

    const res = await mainService.get(
      `/helpPages/GetHelpPage?pageName=${pageName}`
    );

    
    if (res.data != "") {
      this.help = res.data;
      this.markup = res.data.HelpText;
      this.title = res.data.Description;
    } else {
      var title = this.getPageGreekTitle(pageName);
      this.help.HelpText = "";
      this.help.PageName = pageName;
      this.help.Title = title;
      this.help.Description = `Βοήθεια για ${title}`;
      this.help.IsActive = true;
    }
  },
};
</script>

<style scoped>
.dx-htmleditor-content img {
  vertical-align: middle;
  padding-right: 10px;
}

.dx-htmleditor-content table {
  width: 50%;
}

.options {
  padding: 20px;
  background-color: rgba(191, 191, 191, 0.15);
  margin-top: 20px;
}

.caption {
  font-size: 18px;
  font-weight: 500;
}

.option {
  margin-top: 10px;
}
</style>